import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Form, Input, Button, Modal, Upload, Icon } from 'antd'
import { withTranslation } from 'react-i18next'
import styled from 'styled-components'

const FilterContainer=styled.div`
  padding:20px;
`

const MyUpload=styled(Upload)`
  .ant-upload-list-item{
    margin-top:24px;
    height:auto;
    background-color:#F8FAFB;
    padding:14px;
    cursor:pointer;
    color:#2FC29B;
    .ant-upload-list-item-name{
      text-decoration:underline;
    }
    .ant-upload-list-item-info{
      background-color:inherit !important;
    }
  }
  .ant-upload-list-item-info .anticon-paper-clip,
  .ant-upload-list-item .anticon-close{
    margin-top:14px;
    margin-right:14px;
  }
`

const TemplateLink = styled(Button)`
  margin-right:20px;
`;

const Right = styled.div`
  float:right;
`;

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogShow:false,
      fileList:[],
      IMEI:null
    }
  }
  initDialog=()=>{
    this.setState({dialogShow:true})
  }
  handleCancel=()=>{
    this.setState({
      dialogShow:false,
      fileList:[]
    })
  }
  handleOk=()=>{
    this.setState({dialogShow:false})
    this.props.search()
  }
  clear=()=>{
    this.setState({fileList:[],IMEI:null})
    this.props.filterChange('IMEI',null)
    this.props.filterChange('file',null)
    this.props.clear()
  }
  render() {
    const {dialogShow,fileList,IMEI} = this.state
    const {t,filterChange,search,exp} = this.props
    const props = {
      name: 'file',
      accept:'.xls,.xlsx,.csv',
      beforeUpload:(file)=>{
        this.setState(
          {fileList:[file]},
          ()=>{
            filterChange('file',this.state.fileList[0])
          }
        )
        return false
      },
      onPreview(file){
        var aLink=document.createElement('a')
        var blob=new Blob([file])
        aLink.download=file.name
        aLink.href=URL.createObjectURL(blob)
        aLink.click()
      },
      onRemove:()=>{
        this.setState({fileList:[]})
        filterChange('file',[])
      }
    }
    return (
      <FilterContainer>
        <Form layout="inline">
          <Form.Item label="IMEI">
            <Input value={IMEI} allowClear onChange={(e)=>{
              this.setState({IMEI:e.target.value})
              filterChange('IMEI',e.target.value)
            }}>
            </Input>
          </Form.Item>
          {/* <Form.Item>
            <Button type="primary" onClick={this.initDialog}>
              <Icon type="upload"></Icon>
              {t('Import IMEI')}
            </Button>
          </Form.Item> */}
          <Form.Item>
            <Button onClick={()=>{
              this.setState({fileList:[]})
              search(true)
            }}>{t('Search')}</Button>
          </Form.Item>
          <Right>
            <Form.Item>
              <Button onClick={this.clear}>{t('Clear')}</Button>
            </Form.Item>
            {
              !(this.props.roleId === 8 ||this.props.roleId === 9)
              &&
              <Form.Item>
              <Button type="primary" onClick={exp}>{t('Export')}</Button>
             </Form.Item>              
            }
           
          </Right>
        </Form>
        <Modal title={t('Import IMEI')} visible={dialogShow} onOk={this.handleOk} onCancel={this.handleCancel} okText={t('Search')}>
          <MyUpload {...props} fileList={fileList}>
           <div style={{marginBottom:'10px'}}>
           <TemplateLink href={'/api/downloadTpl?type=0'} onClick={(e)=>{e.stopPropagation()}}>{t('Download Template(.xls)')}</TemplateLink>
            <TemplateLink href={'/api/downloadTpl?type=2'} onClick={(e)=>{e.stopPropagation()}}>{t('Download Template(.csv)')}</TemplateLink>
           </div>
            <Button type="primary">
              <Icon type="upload"></Icon>
              {t('Import IMEI')}
            </Button>
          </MyUpload>
        </Modal>
      </FilterContainer>
    )
  }
}

const mapStateToProps = (state) => {
  return {    
    roleId:state.roleId
  }
}
export default connect(mapStateToProps,null)(withTranslation()(Filter))
